// extracted by css-extract-rspack-plugin
var _1 = "uq";
var _2 = "ug";
var _3 = "eq";
var _4 = "xj";
var _5 = "xf";
var _6 = "xc";
var _7 = "xe";
var _8 = "xg";
var _9 = "xi";
var _a = "xb";
var _b = "xh";
var _c = "je";
var _d = "uo";
var _e = "ij";
export { _1 as "arrow", _2 as "carouselComponent", _3 as "carouselContainer", _4 as "centerMode", _5 as "disable", _6 as "fadeAppearance", _7 as "hide", _8 as "isTouchMode", _9 as "nextArrow", _a as "noAnimate", _b as "previousArrow", _c as "slide", _d as "sliderContainer", _e as "withArrows" }
